import React from "react";
import clsx from "clsx";

const Button = ({ children, variant = "primary", size = "md", className, ...props }) => {
  const base = "inline-flex items-center justify-center rounded-md font-medium transition-colors focus:outline-none";
  
  const sizes = {
    sm: "px-3 py-1 text-sm",
    md: "px-4 py-2 text-base",
    lg: "px-6 py-3 text-lg",
  };

  const variants = {
    primary: "bg-primary text-white hover:bg-primary",
    secondary: "bg-gray-100 text-gray-800 hover:bg-gray-200",
    accent: "bg-accent text-white hover:bg-accent",
  };

  return (
    <button className={clsx(base, sizes[size], variants[variant], className)} {...props}>
      {children}
    </button>
  );
};

export default Button;
